import { useDispatch, useSelector } from "react-redux";
import {
  Chip,
  Grid,
  InputAdornment,
  TextField,
  Typography,
  Autocomplete
} from "@mui/material";
import React, {  useEffect, useState } from "react";
import { useForm } from "hooks/useForm";
import RegularButton from "components/CustomButtons/Button";
import BlockIcon from "@mui/icons-material/Block";
import { blue } from "@mui/material/colors";
import { supportCancelApp, supportPrintTicketApp, getUnitsSupport } from "redux/actions/Support/supportActions";
import { validateObject } from "helpers/validateObject";
import LinearProgress from "@mui/material/LinearProgress";
import { orderArrayV2 } from "helpers/orderArray";

export const InputsCancel = () => {
  const dispatch = useDispatch();
  const { stationsList } = useSelector(({ companies }) => companies);
  const { isLoadingComp } = useSelector(({ search }) => search);
  const { unitsConfigArr } = useSelector(({ unitsReducer }) => unitsReducer);

  const {
    inputValues,
    handleNewValues,
    handleInputOnChange,
    cleanForm,
  } = useForm({
    stationOpt: [],
    station: "",
    unitsOpt: [],
    unit: "",
    dispensers: [],
    dispenser: "",
    liters: 0,
    flowMeter: 0,
  });

  const {
    station,
    unit,
    dispensers,
    dispenser,
    liters,
    flowMeter,
  } = inputValues;

  const [open, setOpen] = useState(false);
  const [openCancel, setOpenCancel] = useState(false);

  const handleStation = (e, v) => {
    const value = v || {};
    handleNewValues({
      ...inputValues,
      station: value,
      unit: "",
      dispenser: "",
      dispensers: [],
    });
  };

  const handleUnit = (e, v) => {
    const value = v || "";
    handleNewValues({
      ...inputValues,
      unit: value,
      dispenser: "",
      dispensers: value?.dispensers || [],
    });
  };

  const handleDispenser = (e, v) => {
    const value = v || "";
    handleNewValues({
      ...inputValues,
      dispenser: value,
    });
  };

  const cleanState = () => {
    cleanForm();
    setOpen(false);
    setOpenCancel(false);
  };
  const handleSubmitCancel = () => {
    const id = dispenser?.id ? dispenser.id : unit.id;
    dispatch(supportCancelApp(id, unit.unit_type, cleanState));
  };
  const handleSubmitPrint = () => {
    const id = dispenser?.id ? dispenser.id : unit.id;
    dispatch(
      supportPrintTicketApp(
        id,
        unit.unit_type,
        {
          liters: liters,
          flowMeter: flowMeter,
        },
        cleanState
      )
    );
  };

  useEffect(() => {
    validateObject(station) && dispatch(getUnitsSupport(station.id));
  }, [station]);
  
  return (
    <Grid
      container
      spacing={2}
      style={{
        minWidth: 350,
        maxWidth: 500,
      }}
    >
      <Grid item xs={12} style={{ display: "flex", justifyContent: "center" }}>
        <BlockIcon style={{ color: blue[800], fontSize: 66 }} />
      </Grid>
      <Grid item xs={12}>
        <Autocomplete
          id="combo-box-demo2"
          options={stationsList}
          value={station}
          getOptionLabel={(option) =>
            option.label ? option.label : option.name ? option.name : ""
          }
          renderTags={(value, getTagProps) =>
            value.map((option, index) => (
              <Chip
                variant="outlined"
                label={option?.name ? option.name : option.label}
                {...getTagProps({ index })}
                style={{
                  borderRadius: 4,
                }}
              />
            ))
          }
          renderInput={(params) => (
            <TextField
              {...params}
              label="Estación"
              variant="outlined"
              size="small"
            />
          )}
          fullWidth
          onChange={(e, v) => handleStation(e, v)}
          noOptionsText="No se encuentra la estación"
        />
      </Grid>
      <Grid item xs={12}>
        {isLoadingComp?.unitsSupportLoading ? (
          <LinearProgress />
        ) : (
          <Autocomplete
            id="combo-box-demo3"
            options={orderArrayV2(unitsConfigArr)}
            value={unit}
            getOptionLabel={(option) =>
              option.label ? option.label : option.name ? option.name : ""
            }
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  variant="outlined"
                  label={option?.name ? option.name : option.label}
                  {...getTagProps({ index })}
                  style={{
                    borderRadius: 4,
                  }}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Unidad"
                variant="outlined"
                size="small"
              />
            )}
            fullWidth
            onChange={(e, v) => handleUnit(e, v)}
            noOptionsText="No se encuentra la unidad"
          />
        )}
      </Grid>
      {dispensers.length > 0 && (
        <Grid item xs={12}>
          <Autocomplete
            id="combo-box-demo4"
            options={dispensers}
            value={dispenser}
            getOptionLabel={(option) =>
              option.label ? option.label : option.name ? option.name : ""
            }
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  variant="outlined"
                  label={option?.name ? option.name : option.label}
                  {...getTagProps({ index })}
                  style={{
                    borderRadius: 4,
                  }}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                label="Dispensador"
                variant="outlined"
                size="small"
              />
            )}
            fullWidth
            onChange={(e, v) => handleDispenser(e, v)}
            noOptionsText="No se encuentra el dispensador"
          />
        </Grid>
      )}
      {!open && !openCancel && (
        <Grid item xs={12}>
          <RegularButton
            color="info"
            fullWidth
            disabled={unit ? false : true}
            onClick={() => setOpenCancel(true)}
          >
            Cancelar servicio
          </RegularButton>
        </Grid>
      )}
      {openCancel && (
        <>
          <Grid item xs={12}>
            <Typography variant="h6" align="center">
              ¿Está seguro que desea cancelar el servicio?
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <RegularButton
              color="success"
              fullWidth
              disabled={isLoadingComp?.cancelAppLoading}
              onClick={handleSubmitCancel}
            >
              Confirmar Cancelación
            </RegularButton>
            <Grid item xs={12}>
              <RegularButton
                color="danger"
                fullWidth
                onClick={() => setOpenCancel(false)}
                disabled={isLoadingComp?.cancelAppLoading}
              >
                Atrás
              </RegularButton>
            </Grid>
          </Grid>
        </>
      )}
      {open && (
        <>
          <Grid item xs={12} sm={6}>
            <TextField
              type="number"
              name="flowMeter"
              label="Cuenta Litros"
              value={flowMeter}
              onChange={handleInputOnChange}
              fullWidth
              variant="outlined"
              size="small"
              inputProps={{ min: 0 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">lts</InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              type="number"
              name="liters"
              label="Litros"
              value={liters}
              onChange={handleInputOnChange}
              fullWidth
              variant="outlined"
              size="small"
              inputProps={{ min: 0 }}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">lts</InputAdornment>
                ),
              }}
            />
          </Grid>
        </>
      )}
      <Grid item xs={12}>
        {open ? (
          <RegularButton
            color="success"
            fullWidth
            disabled={!(Number(liters) > 0 && Number(flowMeter) > 0) || isLoadingComp?.printAppLoading}
            onClick={handleSubmitPrint}
          >
            Reimprimir
          </RegularButton>
        ) : (
          !openCancel && (
            <RegularButton
              color="info"
              fullWidth
              disabled={unit ? false : true}
              onClick={() => setOpen(true)}
            >
              Reimprimir ticket
            </RegularButton>
          )
        )}
        {open && (
          <RegularButton
            color="danger"
            fullWidth
            onClick={() => setOpen(false)}
            disabled={isLoadingComp?.printAppLoading}
          >
            Atrás
          </RegularButton>
        )}
      </Grid>
    </Grid>
  );
};
